<template>
    <div>
        <transition-group
            v-if="loading && !items.length"
            mode="out-in"
            name="lb-project-list"
            tag="div"
            class="columns is-multiline is-mobile mx-0 px-5"
            appear
        >
            <div
                v-for="i in 20"
                :key="i"
                class="
                    column
                    is-12-mobile is-6-tablet is-4-desktop is-3-widescreen
                "
            >
                <div class="lb-project-box is-loading"></div>
            </div>
        </transition-group>
        <section v-else>
            <n-projects-grid
                ref="gridProjects"
                :projects="items"
                :showCreationCard="isAppList?false:canCreateProject"
                @deleteProject="deleteProject"
                @addProject="addProject"
                @toggleHighlight="toggleHighlight"
            />
        </section>
    </div>
</template>

<script>
import NProjectsGrid from '@/components/NProjectsGrid';
import _ from 'underscore';
export default {
    components: {
        NProjectsGrid,
    },
    props: {
        items: { type: Array, default: () => [] },
        loading: {
            type: Boolean,
            default: true,
        },
        activeFilter: {
            type: String,
            default: '',
        },
        totalProjects: {
            type: Number,
            default: 0,
        },
        isAppList: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {};
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        canSowCreationCard() {
            // console.log(this.activeFilter);
            if (this.activeFilter == 'mine') {
                return true;
            }
            return false;
        },
        /*canCreateProject() {
            if (this.$store.getters.isLoggedIn && !this.$store.getters.isAnonymous && this.$store.getters.canCreateProject) {
                return true
            } else {
                return false
            }
            
        }*/
        canCreateProject() {
            if (this.isAdmin) {
                return true;
            }
            let canCreate = false;
            // console.log("can create project?",this.isLoggedIn,!this.$store.getters.isAnonymous,this.$store.getters.canCreateProject)
            if (this.isLoggedIn && !this.$store.getters.isAnonymous && this.$store.getters.canCreateProject) {
                // console.log(this.$store.getters.user.entities)
                if (this.$store.getters.user.entities) {
                    // console.log("checking entities permissions")
                    this.$store.getters.user.entities.forEach(element => {
                        
                        if ((element.entity._id == this.$store.getters.user.school._id) && (element.permission != 'GUEST')) {
                            // console.log("no creation")
                            canCreate = true;
                        } /*else {
                            // console.log("can create")
                            canCreate=true
                        }*/
                    });
                } 
                
            }
            // console.log("can create?",canCreate)
            return canCreate;
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
    },
    methods: {
        deleteProject(projectId) {
            if (this.isAppList) {
                return;
            }
            this.$emit('delete', projectId);
        },
        selectProject(project) {
            this.$refs.gridProjects.selectProject(project);
        },
        addProject(){
            //console.log("dashboardcontent")
            if (this.isAppList) {
                return;
            }
            this.$emit('addProject');
        },
        toggleHighlight(project) {
            if (this.isAppList) {
                return;
            }
            this.$emit("toggleHighlight",project)
        }
    },
};
</script>

<style scoped>
router-link {
    cursor: pointer;
}
</style>
